// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var ClientTypeEnum;
(function (ClientTypeEnum) {
    ClientTypeEnum[ClientTypeEnum["WebDesktop"] = 15] = "WebDesktop";
    ClientTypeEnum[ClientTypeEnum["WebInvesting"] = 25] = "WebInvesting";
    ClientTypeEnum[ClientTypeEnum["WebMobile"] = 27] = "WebMobile";
    ClientTypeEnum[ClientTypeEnum["WebTvTradingPlatform"] = 28] = "WebTvTradingPlatform";
})(ClientTypeEnum || (ClientTypeEnum = {}));
class _ClientType {
    constructor() {
        this.currentClientType = ClientTypeEnum.WebDesktop;
    }
    getClientType() {
        return this.currentClientType;
    }
    IsWebDesktop() {
        return this.currentClientType === ClientTypeEnum.WebDesktop;
    }
    IsWebMobile() {
        return this.currentClientType === ClientTypeEnum.WebMobile;
    }
    IsInvesting() {
        return this.currentClientType === ClientTypeEnum.WebInvesting;
    }
    IsTvTradingPlatform() {
        return this.currentClientType === ClientTypeEnum.WebTvTradingPlatform;
    }
    setIsInvesting() {
        this.setClientType(ClientTypeEnum.WebInvesting);
    }
    setIsWebMobile() {
        this.setClientType(ClientTypeEnum.WebMobile);
    }
    setIsTvTradingPlatform() {
        this.setClientType(ClientTypeEnum.WebTvTradingPlatform);
    }
    setClientType(clientType) {
        this.currentClientType = clientType;
    }
}
export const ClientType = new _ClientType();
